import { IExtensionLink, IExtensionLinkPlatform } from '../interfaces/responses/profile'

export const $factSheetLink = (type: IExtensionLinkPlatform, json: IExtensionLink[]) =>
  json.find(({ platform }) => platform === type) || null
